import { makeAutoObservable } from "mobx";
import quoteModal from "../../Configs/JSON/quoteModal.json";

const theme = {
  GPPIA: {
    key: "GPPIA",
  },
  GPPDA: {
    key: "GPPDA",
  },
  GPPIANPS: {
    key: "GPPIANPS",
  },
};
class FormStore {
  calc_type = theme["GPPIA"]; // GPP-DA, GPP-IA-NPS
  calc_buyingFor = "self";
  calc_gender = "Male";
  // calc_OneTimeInvestment = "1000000"
  calc_age = "";
  calc_dob = "";
  calc_phone = "";
  calc_email = "";
  calc_marital = undefined;
  calc_occupation = "";
  calc_checkOne = true;
  calc_checkTwo = true;
  calc_clickOne = false;
  calc_clickTwo = true;
  persona_Validity = false;
  calc_aiModal = false;
  calc_mobModal = false;
  calc_suitability = false;
  calc_city = "";
  // Quote Modal
  quote_formTab = "1";
  quote_modal = false; // Quote Page
  quote_modalLoader = true; // Quote Loader
  quote_NPS = "N";

  quote_invest = 200000;
  quote_annuityAmount = "";
  quote_nudgeRange = 0;
  quote_annuityFreq = "Yearly";
  quote_RecAnnuityFreq = 10;
  quote_MockRecAnnuityRate = "10%";
  quote_Pension = "Me_&_Nominee";

  quote_Sort = false;
  quote_ShowPlan = false;
  quote_PlanSelected = 1;
  quote_PlanSelectedObj = {};

  quote_cardTwoCheckBox = false;
  quote_cardLoader = true; // Quote Card Loader

  quote_checkOne = true;
  quote_checkTwo = false;
  quote_checkThree = true;

  quote_cardList = [];

  joint_fullName = "";
  joint_DOB = "";
  joint_Age = "";
  joint_life = "Father";
  join_data_Show = false;

  pensionWithVal = 0;
  pensionWithoutVal = 0;
  extraSavings = 0;
  totalPension = 0;
  benifitsTitle = "";
  pensionTitle = "";

  quoteScreen = "false";
  annuity = "ImmediateAnnuity";
  api_value = 0;
  quote_OptionalLead = "";
  suitabilityFlag = "";
  quote_isEBIError = false;
  existingCustDetails = {};
  PiiMaskFlag = false;

  constructor() {
    makeAutoObservable(this);
  }

  setCalcBuyingFor = (data) => (this.calc_buyingFor = data);
  setCalcGender = (data) => (this.calc_gender = data);
  // setCalcOneTimeInvestment = (data) => (this.calc_OneTimeInvestment = data)
  setCalcMarital = (data) => (this.calc_marital = data);
  setCalcDob = (data) => (this.calc_dob = data);
  setCalcAge = (data) => (this.calc_age = data);
  setCalcPhone = (data) => (this.calc_phone = data);
  setCalcEmail = (data) => (this.calc_email = data);
  setCalcCheckOne = (data) => (this.calc_checkOne = data);
  setCalcCheckTwo = (data) => (this.calc_checkTwo = data);
  setCalcClickOne = (data) => (this.calc_clickOne = data);
  setCalcClickTwo = (data) => (this.calc_clickTwo = data);
  setCalcOccupation = (data) => (this.calc_occupation = data);
  setCalcCity = (data) => (this.calc_city = data);

  setAIModal = (data) => (this.calc_aiModal = data);
  setMobileModal = (data) => (this.calc_mobModal = data);
  setSuitabilityModal = (data) => (this.calc_suitability = data);

  // Quote
  setQuoteModal = (data) => (this.quote_modal = data);
  setQuoteModalLoader = (data) => (this.quote_modalLoader = data);
  setQuoteFormTab = (data) => (this.quote_formTab = data);
  setQuoteInvest = (data) => (this.quote_invest = data);
  setQuoteAnAmount = (data) => (this.quote_annuityAmount = data);
  setNudgeRange = (data) => (this.quote_nudgeRange = data);
  setQuoteAnFreq = (data) => (this.quote_annuityFreq = data);
  setQuoteRecAnFreq = (data) => (this.quote_RecAnnuityFreq = data);
  setQuoteMocKRecAnRate = (data) => (this.quote_MockRecAnnuityRate = data);
  setEBIError = (data) => (this.quote_isEBIError = data);
  setQuoteNPS = (data) => (this.quote_NPS = data);
  setQuotePension = (data) => (this.quote_Pension = data);

  setQuoteSort = (data) => (this.quote_Sort = data);
  setQuoteShowMore = (data) => (this.quote_ShowPlan = data);
  setPlanSelected = (data) => (this.quote_PlanSelected = data);
  setPlanSelectedObj = (data) => (this.quote_PlanSelectedObj = data);

  setQuoteCardList = (data) => (this.quote_cardList = data);
  setQuoteCardLoader = (data) => (this.quote_cardLoader = data);

  setQuoteCheckOne = (data) => (this.quote_checkOne = data);
  setQuoteCheckTwo = (data) => (this.quote_checkTwo = data);
  setQuoteCheckThree = (data) => (this.quote_checkThree = data);

  setJointFullName = (data) => (this.joint_fullName = data);
  setJointDOB = (data) => (this.joint_DOB = data);
  setJointAge = (data) => (this.joint_Age = data);
  setJointLife = (data) => (this.joint_life = data);
  setJDataShow = (data) => (this.join_data_Show = data);

  setPensionWithVal = (data) => (this.pensionWithVal = data);
  setPensionWithoutVal = (data) => (this.pensionWithoutVal = data);
  setExtraSavings = (data) => (this.extraSavings = data);
  setTotalPension = (data) => (this.totalPension = data);
  setBenefitsTitle = (data) => (this.benifitsTitle = data);
  setPensionTitle = (data) => (this.pensionTitle = data);

  setQuoteScreen = (data) => (this.quoteScreen = data);
  setAnnuity = (data) => (this.annuity = data);
  setApiValue = (data) => (this.api_value = data);
  setOptionalLead = (data) => (this.quote_OptionalLead = data);

  setSuitabilityFlag = (data) => (this.suitabilityFlag = data);
  setPersonaValidity = (data) => (this.persona_Validity = data);
  setCalcType = (data) => (this.calc_type = theme[data]);
  setExistingCustDetails = (data) => (this.existingCustDetails = data);
  setPiiMaskFlag = (data) => (this.PiiMaskFlag = data);
}

export default new FormStore();
